import { render } from "./Register.vue?vue&type=template&id=12cdba36&scoped=true&ts=true"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"

import "./Register.vue?vue&type=style&index=0&id=12cdba36&lang=scss&scoped=true"

import exportComponent from "/app/apps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cdba36"]])

export default __exports__